import React from 'react';
import ReactDOM from 'react-dom';
import { ConnectedRouter } from 'connected-react-router';
import { BrowserRouter as Router } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import store, { history, persistor } from 'src/store';

import App from './App';

import 'src/assets/css/app.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { SocketProvider } from './components/hooks/socketConnector';
import { PostHogProvider } from 'posthog-js/react';

const options = {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

if (document.getElementById('automation')) {
  ReactDOM.render(
    <PostHogProvider apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY} options={options}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ConnectedRouter history={history}>
            <SocketProvider>
              <App />
            </SocketProvider>
          </ConnectedRouter>
        </PersistGate>
      </Provider>
    </PostHogProvider>,

    document.getElementById('automation'),
  );
}
serviceWorker.unregister();
